import {useEffect,useState} from 'react';
import {actionButtonFor,availableKeys,type FormKey} from '../app/function-keys';

type Cap={key:string;label:string};

/** Label of the toolbar action behind a key, read from the button itself so the strip never advertises a fake action. */
function capsFor(root:ParentNode):Cap[]{
 return availableKeys(root).map((key:FormKey)=>{
  const button=actionButtonFor(root,key);
  const label=[...(button?.childNodes||[])].filter(n=>!(n instanceof HTMLElement&&n.matches('.kbd,kbd'))).map(n=>n.textContent||'').join('').trim();
  return {key,label:label||key};
 });
}

const FIELD_KEYS:Cap[]=[
 {key:'F9',label:'List of values'},
 {key:'Enter',label:'Next field'},
 {key:'⇧Tab',label:'Previous'},
 {key:'↑↓',label:'Rows / list'},
 {key:'Esc',label:'Close list'},
];

/**
 * Oracle Forms-style key strip pinned under the workspace. It lists the function keys that are live on the current
 * screen (enabled toolbar actions) plus the field keys every form shares.
 */
export function ShortcutStrip({workspaceId='workspace'}:{workspaceId?:string}){
 const [caps,setCaps]=useState<Cap[]>([]);
 useEffect(()=>{
  const root=document.getElementById(workspaceId);
  if(!root)return;
  let frame=0;
  const refresh=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
   const next=capsFor(root);
   setCaps(prev=>prev.length===next.length&&prev.every((c,i)=>c.key===next[i]!.key&&c.label===next[i]!.label)?prev:next);
  })};
  refresh();
  const observer=new MutationObserver(refresh);
  observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
  return ()=>{observer.disconnect();cancelAnimationFrame(frame)};
 },[workspaceId]);
 return <div className="key-strip no-print" role="note" aria-label="Keyboard shortcuts">
  <div className="key-strip-group">{caps.length?caps.map(c=><span className="key-cap" key={c.key}><kbd>{c.key}</kbd>{c.label}</span>):<span className="key-strip-empty">No function-key actions on this screen</span>}</div>
  <div className="key-strip-group fields">{FIELD_KEYS.map(c=><span className="key-cap" key={c.key}><kbd>{c.key}</kbd>{c.label}</span>)}</div>
 </div>;
}
